import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { AuthorizationsList } from 'shell/models/feature';
//import { readFileAsBase64 } from 'shell/utils/file-to-base64';
import FormOperator from 'system/components/operators/form';
import { OperatorType } from 'system/components/operators/form/constants';
import { CommonOperatorCrumbs } from 'system/constants/common-operator-crumbs';
import { OperatorForm } from 'system/view-models/operator';

const OperatorNewPage = (): React.ReactElement => {
  const { post: insertOperator } = useHttpFetch(`${__MANAGEMENT_API_URL__}/operatori`);

  const navigate = useNavigate();

  const onSubmit = useCallback(
    async (formValues) => {
      insertOperator({
        key: {
          codiceOperatore: formValues?.operator?.code || undefined,
          codiceEnte: formValues?.operator?.institution || undefined,
        },
        timestampUltimoAccesso: formValues?.operator?.lastLoginDateTime,
        dataCancellazione: formValues?.operator?.cancellationDate?.toFormat('yyyy-MM-dd'),
        note: formValues?.operator?.lastUpdate || undefined,
        codiceQualifica: formValues?.operator?.qualification || undefined,
        cognomeNome: formValues?.operator?.name || undefined,
        codiceFiscale: formValues?.operator?.fiscalCode || undefined,
        tipoOperatore: formValues?.operator?.typeOperator || undefined,
        codiceServizio: formValues?.operator?.service || undefined,
        codana: formValues?.operator?.codAna
          ? Number.parseInt(formValues?.operator?.codAna, 10)
          : undefined,
        userEstesa: formValues?.operator?.extCode || undefined,
        email: formValues?.operator?.email || undefined,
        dominio: formValues?.operator?.organizationEmail || undefined,
        dataScadenza: formValues?.operator?.authorizationExpiration || undefined,
        operatoreAnpr:
          formValues?.anpr?.validityEnd ||
          formValues?.anpr?.validityStart ||
          formValues?.anpr?.stationIdAnpr
            ? {
                key: {
                  codice: formValues?.operator?.code || undefined,
                  codiceEnte: formValues?.operator?.institution || undefined,
                },
                codiceAnpr: formValues.anpr.anprOperatorCode || undefined,
                dataInizioValidita: formValues?.anpr?.validityStart || undefined,
                dataFineValidita: formValues?.anpr?.validityEnd || undefined,
                idPostazione:
                  formValues?.anpr?.stationIdAnpr?.id?.toString() === OperatorType.InternalOperator
                    ? '2'
                    : formValues?.anpr?.stationIdAnpr?.id?.toString() ===
                      OperatorType.ExternalOperator
                    ? '1'
                    : formValues?.anpr?.stationIdAnpr?.id || undefined,
                // certPostazione: {
                //   codicePostazioneAnpr: formValues?.anpr?.stationIdAnpr,
                //   certificato: certificate,
                //   aliasCertificato: formValues?.anpr?.certificateName,
                //   password: formValues?.anpr?.certificatePassword,
                //   dataInizioValidita: formValues?.anpr?.validityStartCertificate,
                //   dataFineValidita: formValues?.anpr?.validityEndCertificate,
                // },
              }
            : undefined,
        operatoreProfiloList: [
          {
            key: {
              codiceProfilo: formValues?.operator?.profile || undefined,
              codiceOperatore: formValues?.operator?.code || undefined,
              codiceEnte: formValues?.operator?.institution || undefined,
            },
          },
        ],
        operatoreServizioList: (formValues?.services?.servicesList || []).map(
          (service: string) => ({
            key: {
              codiceOperatore: formValues?.operator?.code,
              codiceServizio: service,
              codiceEnte: formValues?.operator?.institution,
            },
          })
        ),
        tipoFeatureAuthOperatoreList: formValues?.feature?.authorizationsList?.map(
          (item: AuthorizationsList) => ({
            key: {
              codiceFeature: item.id,
              codiceOperatore: formValues?.operator?.code,
              codiceEnte: formValues?.operator?.institution,
            },
            valoreFeatureAuthOpe: item.value.split(' ')[0],
          })
        ),
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/operatori');
      });
    },
    [insertOperator, navigate]
  );

  const initialValues: OperatorForm | undefined = Object.freeze({
    feature: {},
    services: { page: 0, rowsPerPage: 10, servicesList: [] },
    operator: {
      name: '',
      institution: '',
      qualification: '',
      service: '',
      profile: '',
      email: '',
      typeOperator: '',
      organizationEmail: '',
      fiscalCode: '',
      code: '',
      extCode: '',
      cancellationDate: null,
      lastLoginDateTime: null,
    },
    anpr: {
      anprOperatorCode: '',
      stationIdAnpr: null,
      validityStart: null,
    },
  });

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonOperatorCrumbs, { name: 'Nuovo Operatore' }]} />
      <FormOperator
        title="Nuovo Operatore"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/sistema/operatori');
        }}
        initialValues={initialValues}
      />
    </Fragment>
  );
};

OperatorNewPage.displayName = 'Operator new page component';

export default OperatorNewPage;
